import React from 'react';
import {Stack} from '@mui/material';
import type {FCWithChildren} from 'types';
import {ColorPalette} from '../../theme';

type Props = {
  horizontal?: boolean;
  tight?: boolean;
};

export const FieldLayout: FCWithChildren<Props> = ({
  horizontal = false,
  tight = false,
  children,
}) => {
  return (
    <Stack
      direction={horizontal ? 'row' : 'column'}
      spacing={tight ? 0 : 2}
      sx={{
        color: ColorPalette.primary.burgundy,
        flex: horizontal ? '1' : undefined,
      }}>
      {children}
    </Stack>
  );
};
